module.exports = __webpack_public_path__ + "static/media/padlock.a1f399f5.svg";